import { all } from 'redux-saga/effects';

import atualizarContato from './atualizarContato/saga';
import pesquisarContato from './pesquisarContato/saga';

export default all([atualizarContato, pesquisarContato]);
